import React from "react";
import { useIntl } from "react-intl";

export const TEST_ID_TOO_MANY_REQUESTS = "too-many-requests";

const TooManyRequests: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="ma3 tc" data-testid={TEST_ID_TOO_MANY_REQUESTS}>
      <h1>
        {formatMessage({
          id: "tooManyRequests.title",
        })}
      </h1>
      <p className="f4">
        {formatMessage({
          id: "tooManyRequests.body",
        })}
      </p>
    </div>
  );
};

export default TooManyRequests;
